import React from 'react';
import { CheckCircle2, Clock, AlertCircle } from 'lucide-react';
import { MerchantInvoice } from '../../types/gst';

interface Props {
  invoices: MerchantInvoice[];
  financialYear: string;
}

export const InvoiceMetricsRow: React.FC<Props> = ({ invoices, financialYear }) => {
  const totalSales = invoices.reduce((acc, inv) => acc + (inv.grandTotal || 0), 0);
  const totalPaid = invoices.reduce((acc, inv) => acc + (inv.paidAmount || 0), 0);
  const totalBalance = invoices.reduce((acc, inv) => acc + (inv.balanceDue || 0), 0);
  const overdueCount = invoices.filter(
    i => i.status === 'OVERDUE' || (i.balanceDue > 0 && new Date(i.dueDate) < new Date())
  ).length;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <div className="rounded-2xl border border-white/10 bg-[#131316] p-4 text-xs space-y-1">
        <div className="text-[10px] uppercase font-bold text-slate-400">Total Billed ({financialYear})</div>
        <div className="text-xl font-bold text-white font-mono">
          ₹{totalSales.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
        </div>
        <div className="text-[10px] text-slate-500">{invoices.length} Invoices Issued</div>
      </div>

      <div className="rounded-2xl border border-emerald-500/25 bg-emerald-950/20 p-4 text-xs space-y-1">
        <div className="text-[10px] uppercase font-bold text-emerald-400 flex items-center gap-1">
          <CheckCircle2 className="h-3.5 w-3.5" />
          <span>Payments Collected</span>
        </div>
        <div className="text-xl font-bold text-emerald-300 font-mono">
          ₹{totalPaid.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
        </div>
        <div className="text-[10px] text-emerald-400/70">Realized Cash, UPI & NEFT</div>
      </div>

      <div className="rounded-2xl border border-amber-500/25 bg-amber-950/20 p-4 text-xs space-y-1">
        <div className="text-[10px] uppercase font-bold text-amber-400 flex items-center gap-1">
          <Clock className="h-3.5 w-3.5" />
          <span>Balance Outstanding</span>
        </div>
        <div className="text-xl font-bold text-amber-300 font-mono">
          ₹{totalBalance.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
        </div>
        <div className="text-[10px] text-amber-400/70">Pending customer receivables</div>
      </div>

      <div className="rounded-2xl border border-rose-500/25 bg-rose-950/20 p-4 text-xs space-y-1">
        <div className="text-[10px] uppercase font-bold text-rose-400 flex items-center gap-1">
          <AlertCircle className="h-3.5 w-3.5" />
          <span>Overdue Invoices</span>
        </div>
        <div className="text-xl font-bold text-rose-300 font-mono">{overdueCount}</div>
        <div className="text-[10px] text-rose-400/70">Past due date &bull; Send WhatsApp nudge</div>
      </div>
    </div>
  );
};
